'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

var checkRefreshToken = function (accessToken, refreshToken, langCode, baseURL) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, res;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                searchParams = JSON.stringify({
                    accessToken: accessToken,
                    refreshToken: refreshToken
                });
                return [4 /*yield*/, fetch("".concat(baseURL, "/api/v1/checkExpireSessionWS"), {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                            'Accept-Language': langCode,
                            'Cache-Control': 'no-cache'
                        },
                        body: searchParams
                    })
                        .then(function (res) { return res.json(); })
                        .catch(function (e) { return console.log(e); })];
            case 1:
                res = _d.sent();
                if ((res === null || res === void 0 ? void 0 : res.data) && (res === null || res === void 0 ? void 0 : res.data.length) > 0 && ((_a = res === null || res === void 0 ? void 0 : res.data[0]) === null || _a === void 0 ? void 0 : _a.attributes)) {
                    return [2 /*return*/, (_c = (_b = res === null || res === void 0 ? void 0 : res.data[0]) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.isExpireSessionWS];
                }
                else {
                    return [2 /*return*/, false];
                }
        }
    });
}); };

export { checkRefreshToken };
//# sourceMappingURL=services.js.map
